import { isVideoArticlePage } from '../../utils/aem-utils';
import { IS_HIDDEN_CLASSNAME } from '../../utils/dom-utils';
import { isSticky } from '../sticky-hero-player/helpers';

import { DISCLAIMER_CLASSNAME, DISCLAIMER_TEXT_CLASSNAME, DISCLAIMER_TEXT_SCROLL_MODIFIER } from './constants';

export const heroDisclaimer = ({ elementToAppendTo }) => {
  const getDisclaimerElement = () => document?.querySelector(`.${DISCLAIMER_CLASSNAME}`);

  const render = ({ disclaimerTitle, disclaimerClassNameModifiers = [] }) => {
    if (getDisclaimerElement()) {
      return;
    }
    const $disclaimerDiv = document.createElement('div');
    $disclaimerDiv.className = DISCLAIMER_CLASSNAME;
    const $disclaimerSpan = document.createElement('span');
    $disclaimerSpan.className = DISCLAIMER_TEXT_CLASSNAME;
    $disclaimerSpan.textContent =
      new DOMParser().parseFromString(disclaimerTitle, 'text/html')?.body?.textContent || disclaimerTitle;
    $disclaimerDiv.appendChild($disclaimerSpan);

    if (!isVideoArticlePage() && !isSticky()) {
      $disclaimerDiv.classList.add(IS_HIDDEN_CLASSNAME);
    }

    if (disclaimerClassNameModifiers.length) {
      disclaimerClassNameModifiers.forEach((modifier) => {
        $disclaimerDiv.classList.add(`${DISCLAIMER_CLASSNAME}--${modifier}`);
      });
    }

    console.info(`Hero disclaimer rendered:`, elementToAppendTo);
    elementToAppendTo.appendChild($disclaimerDiv);
  };

  const dispose = () => {
    const $existingDisclaimer = getDisclaimerElement();
    if ($existingDisclaimer) {
      $existingDisclaimer.remove();
    }
  };

  return { render, dispose, getDisclaimerElement };
};
